module.exports = __webpack_public_path__ + "static/media/no-events-graphic.8187331e.svg";